<template>
    <div id="editor_outlineList">
        <!-- 编辑 -->
        <div class="editor_outlineList" v-for="(item, i) in noveloutline" :key="i">
            <el-input v-model="item.name" readonly @input="handler(noveloutline)" placeholder="请输入标题"></el-input>
            <el-input v-model="item.content" readonly @input="handler(noveloutline)" type="textarea" placeholder="请输入内容"
                :autosize="true"></el-input>
            <!-- <div class="editor_del_btn cursor_1" v-if="isEdit"><el-checkbox :value="item.name"></el-checkbox></div> -->
            <div class="editor_del_btn cursor_1" title="删除" v-if="isEdit" @click="del(item, i)"><i
                    class="el-icon-delete"></i></div>
            <div class="editor_edit_btn cursor_1" title="修改" v-if="isEdit" @click="edit(item, i)"><i
                    class="el-icon-edit"></i></div>
        </div>
        
        <!-- 手动续写 -->
        <div class="editor_outlineList1" ref="editorOutlineList1" v-if="handShow">
            <el-input type="textarea" :placeholder="handPlaceholder" @input="handInput" v-model="handText"
                show-word-limit :maxlength="200000">
            </el-input>
        </div>
    </div>
</template>
<script>
import { EventBus } from '@/utils/eventBus';

export default {
    props: {
        noveloutline: {
            type: Array,
            default: []
        },
        isEdit: {
            type: Boolean,
            default: false
        },
        editType: {
            type: String | Number,
            default: ''
        },
    },
    data() {
        return {
            outlineNum: 0, // 字数
            handPlaceholder: '请长按粘贴或者输入您的大纲:大纲格式请参考”官方动态-我有大纲格式标准”',
            handText: '',
            handShow: false,
            checkList: [],//选中的
        };
    },
    mounted() {
        EventBus.$on('handwriting', (item, content = '') => {
            console.log('item=', item)
            console.log('content=',content)
            if (item) {
                this.handShow = true
                this.handText = content || ''
                if(content){
                    this.handInput()
                }
                this.$nextTick(() => {
                    this.scrollToBottom();
                });
            } else {
                this.handShow = false
                this.handText = ''
            }

        });
    },
    beforeDestroy() {
        EventBus.$off('handwriting');
    },
    watch: {
        noveloutline: {
            deep: true,
            handler: 'handler'
        }
    },
    created() {
        this.handler(this.noveloutline);
    },
    methods: {
        handler(newVal) {
            this.outlineNum = newVal.reduce((total, item) => {
                return total + item.name.length + item.content.length;
            }, 0);
            this.$emit('getoutlineNum', {
                num: this.outlineNum,
                list: this.noveloutline
            });
            sessionStorage.setItem('ifeditStatus', true);
        },
        handInput() {
            this.outlineNum += this.handText.length
            this.$emit('getoutlineNum', {
                num: this.outlineNum,
                list: this.noveloutline,
                handText: this.handText
            });
        },
        scrollToBottom() {
            if (this.$refs.editorOutlineList1) {
                this.$refs.editorOutlineList1.scrollIntoView({ behavior: 'auto' });
            }
        },
        del(item, i) {
            console.log('删除=', item, ' i=', i)
            this.$emit('del', { index: i, id: item.id || -1, item })
        },
        edit(item, i) {
            console.log('编辑=', item, ' i=', i)
            this.$emit('edit', { index: i, id: item.id || -1, item })
        }
    }
};
</script>
<style>
#editor_outlineList .el-input__inner {
    font-weight: bold;
    font-size: 16px;
    color: #111111;
    height: 32px;
    border: none;
    padding: 0;
}

#editor_outlineList .el-textarea__inner {
    font-size: 16px;
    color: #111111;
}

.editor_outlineList {
    position: relative;
}

.editor_outlineList1 {
    margin-top: 20px;
    height: 100%;
}

.editor_outlineList1 .el-textarea {
    height: 100%;
}

.editor_outlineList1 .el-textarea .el-textarea__inner {
    height: 300px;
}



.editor_del_btn {
    position: absolute;
    right: 10px;
    top: 8px;
    color: var(--tech-primary);
}

.editor_edit_btn {
    position: absolute;
    right: -15px;
    top: 8px;
    color: var(--tech-primary);
}
</style>